<template lang="pug">
div.my-4
  template(v-for="medication in getMedications")
    .d-flex.align-center.my-4(:class="{ 'clickable': !readonly }" @click="onClickSelection(medication)")
      yc-checkbox.mr-2(v-if="!readonly" v-model="selectedMedication" :value="medication" :disabled="isDisabledToSelect")
      .text-xs.neutral700--text {{ medication.name }}
  .d-flex.justify-end.mt-4
    v-btn.button-sm.mr-3(v-if="!readonly" color="primary" :disabled="!canAddToCurrent" outlined :loading="isLoadingAddToCurrent" @click="onAddToCurrent") {{ $t('add_to_current') }}
    v-btn.button-sm(color="primary" :disabled="isDisabledToViewDetails" depressed @click="$emit('viewDetails')") {{ $t('view_details') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    parentHistory: {
      type: Object,
      required: true
    },
    parentRegistration: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedMedication: [],
      isLoadingAddToCurrent: false
    }
  },
  computed: {
    leadPid() {
      return this.$route.params.pid
    },
    getMedications() {
      return this.parentHistory?.medications ?? []
    },
    isDisabledToSelect() {
      return this.parentRegistration.status !== 'serving'
    },
    isDisabledToViewDetails() {
      return this.getMedications.length === 0
    },
    canAddToCurrent() {
      if (this.isDisabledToViewDetails) {
        return false
      }
      return this.selectedMedication.length > 0
    },
    payload() {
      return this.selectedMedication.map(medication => this.filterPayloadObject(medication))
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    onClickSelection(value) {
      if (this.readonly) return
      if (this.isDisabledToSelect) {
        this.showMessage(['error', this.$t('error_message.call_patient_in_first')])
        return
      }
      if (this.selectedMedication.includes(value)) {
        this.selectedMedication = this.selectedMedication.filter(x => x !== value)
      } else {
        this.selectedMedication.push(value)
      }
    },
    filterPayloadObject(obj) {
      const allowedProperties = ['product', 'quantity', 'price', 'extra_data']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      filteredObj.product = filteredObj.product.id
      return filteredObj
    },
    async onAddToCurrent() {
      this.isLoadingAddToCurrent = true
      try {
        await this.$axios.patch(`/leads/${this.leadPid}`, { products: this.payload })
        this.$emit('updated')
        this.selectedMedication = []
      } catch (err) {
        let message = this.$t('error_message.unable_to_complete_request')
        if (err.response?.status === 400 && err.response?.data?.code === '444101') {
          message = 'Item quantity more than available stock. Please adjust the quantity'
        }       
        if (err.response.data) {
          if (err.response.data.detail) {
            message = err.response.data.detail
          } else {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) { message = data }
          }
        }
        this.showMessage(['error', message])
      } finally {
        this.isLoadingAddToCurrent = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>